






















import { Component, Vue, Prop } from "vue-property-decorator";
import { vxm } from "@/store.vuex";
@Component
export default class ReferralSearch extends Vue {
  @Prop() searchText;
  private searchPlaceholder:string = 'Search here by Job name, ID and location';
  mounted() {
    this.searchPlaceholder = this.$t(
      'myreferrals.search-placeholder',
    ).toString();
    const element = <HTMLInputElement>this.$refs.search;
    element.focus();
  }
}
